const STATES = {
  SUCCESS: 'success',
  FAILED: 'failed',
  CUESTION: 'cuestion',
  SUCCESS_DELETE: 'success-delete',
  FAILED_DELETE: 'failed-delete',
};

class WageAdvanceModalController {
  constructor() {
    this.states = STATES;
  }

  getModalShow(item) {
    return this.modalToShow === item;
  }
}

export default WageAdvanceModalController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceModal/wageAdvanceModal.controller.js